import { MODULES } from "../routes";

export const RF_KEY_PROJECT = "TOMSACHS|RF";
export const RF_ROUTE = `${MODULES}/rocket_factory`;

export const TIMELINE = `${RF_ROUTE}/timeline/list`;
export const TIMELINE_MODIFY = `${TIMELINE}/:uuid/modify`;
export const TIMELINE_CREATE = `${TIMELINE}/create`;
export const TIMELINE_DETAIL = `${TIMELINE}/:uuid/detail`;
